module.exports = __webpack_public_path__ + "./docs/img/icon-module.24a0217f3a185c264b2b00550fac6f7a.svg";